/**
 * @generated SignedSource<<305a92196b7b677a220f8b2b96eb5dc8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addAreaBackgroundRulePanel_AssignProductMutation$variables = {
  productIds: ReadonlyArray<number>;
  ruleId: string;
};
export type addAreaBackgroundRulePanel_AssignProductMutation$data = {
  readonly assignProductsToAreaBackgroundRule: {
    readonly result: boolean;
  };
};
export type addAreaBackgroundRulePanel_AssignProductMutation = {
  response: addAreaBackgroundRulePanel_AssignProductMutation$data;
  variables: addAreaBackgroundRulePanel_AssignProductMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ruleId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "productIds",
        "variableName": "productIds"
      },
      {
        "kind": "Variable",
        "name": "ruleId",
        "variableName": "ruleId"
      }
    ],
    "concreteType": "ProductAssignmentResult",
    "kind": "LinkedField",
    "name": "assignProductsToAreaBackgroundRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "addAreaBackgroundRulePanel_AssignProductMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "addAreaBackgroundRulePanel_AssignProductMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "071cdc127636a947640779598f49c39b",
    "id": null,
    "metadata": {},
    "name": "addAreaBackgroundRulePanel_AssignProductMutation",
    "operationKind": "mutation",
    "text": "mutation addAreaBackgroundRulePanel_AssignProductMutation(\n  $ruleId: ID!\n  $productIds: [Long!]!\n) {\n  assignProductsToAreaBackgroundRule(ruleId: $ruleId, productIds: $productIds) {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "59b87cd349f9a4337ffbef386a3ed96e";

export default node;
